export default __webpack_public_path__ + "static/shut-up-bfe48bda26b87251a9aab3ca90aade3a.jpg";